import React from "react";

import { Icon, IconName } from "../Icon";

import { IconButtonStyle } from "./styles";
import { ButtonColor, ButtonSize, ButtonVariant } from "./types";

export type IconButtonProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  "color" | "name" | "children"
> & {
  name: IconName;
  filled?: boolean;
  isLoading?: boolean;
  variant?: ButtonVariant;
  color?: ButtonColor;
  size?: ButtonSize;
};

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      variant = "primary",
      color = "primary",
      size = "medium",
      name,
      isLoading,
      filled,
      onClick,
      ...props
    },
    ref
  ) => {
    return (
      <IconButtonStyle
        ref={ref}
        variant={variant}
        color={color}
        size={size}
        onClick={isLoading ? () => {} : onClick}
        {...props}
      >
        {isLoading ? (
          <IconButtonStyle.RotatingContainer>
            <Icon name="progressActivity" />
          </IconButtonStyle.RotatingContainer>
        ) : (
          <Icon name={name} filled={filled} />
        )}
      </IconButtonStyle>
    );
  }
);
